<template>
  <section class="main-section main-section--white">
    <div class="container">
      <div class="text-center add-margin-bottom-full">
        <h2 class="h1 text-capitalize add-margin-bottom">{{ tag }}</h2>
      </div>

      <component
        :is="selectedLayout"
        :entries="contents"
      />
    </div>
  </section>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import ContentGridView from '@/components/contents/ContentLayoutGridView'
import ContentListView from '@/components/contents/ContentLayoutListView'

export default {
  name: 'TagsPage',
  components: {
    ContentGridView,
    ContentListView
  },
  computed: {
    ...mapState({
      contents: state => state.contents.contents
    }),
    ...mapGetters([
      'isGridLayout'
    ]),
    selectedLayout () {
      return this.isGridLayout ? 'ContentGridView' : 'ContentListView'
    },
    tag () {
      return this.$route.params.tag
    }
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler ($route) {
        this.fetchContent()
      }
    }
  },
  methods: {
    ...mapActions({
      fetchContents: 'contents/fetch',
      setContents: 'contents/apply',
      resetContents: 'contents/reset',
      resetContentFilter: 'contentFilter/reset'
    }),
    fetchContent () {
      this.resetContentFilter()
      const tags = this.$route.params.tag.split(',')
      this.$store.dispatch('contentFilter/setTags', tags)
      this.fetchContents()
        .then((response) => {
          this.setContents(response)
          this.$emit('loadingDone')
        })
    }
  },
  created () {

  },
  beforeDestroy () {
    this.resetContentFilter()
    this.resetContents()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tags/TagsPage.vue